import { Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MenubarModule } from 'primeng/menubar';
import { MenuModule } from 'primeng/menu';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { filter } from 'rxjs';
import { environment } from './environments/environment';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    MenubarModule,
    MenuModule,
    TranslateModule,
    ButtonModule,
    SelectModule,
    FormsModule,
  ],
  providers: [],
  template: `
    <router-outlet />

    <a
      class="whatsapp-float-button"
      href="https://wa.me/16897775629"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Speak to support on WhatsApp"
    >
      <svg
        viewBox="0 0 32 32"
        aria-hidden="true"
        focusable="false"
      >
        <path
          fill="currentColor"
          d="M19.11 17.34c-.27-.14-1.59-.78-1.84-.87-.25-.09-.43-.14-.61.14-.18.27-.7.87-.86 1.05-.16.18-.32.2-.59.07-.27-.14-1.14-.42-2.17-1.34-.8-.71-1.35-1.59-1.5-1.86-.16-.27-.02-.42.12-.56.13-.13.27-.32.41-.48.14-.16.18-.27.27-.46.09-.18.05-.34-.02-.48-.07-.14-.61-1.48-.84-2.03-.22-.52-.45-.45-.61-.46h-.52c-.18 0-.48.07-.73.34s-.95.93-.95 2.28.98 2.65 1.11 2.83c.14.18 1.93 2.95 4.67 4.13.65.28 1.16.45 1.56.58.66.21 1.26.18 1.73.11.53-.08 1.59-.65 1.82-1.27.23-.61.23-1.14.16-1.25-.07-.11-.25-.18-.52-.32Z"
        />
        <path
          fill="currentColor"
          d="M16.01 3.2c-6.96 0-12.61 5.64-12.61 12.59 0 2.22.58 4.39 1.69 6.3L3.2 28.8l6.9-1.81a12.64 12.64 0 0 0 5.91 1.5h.01c6.95 0 12.59-5.65 12.59-12.6 0-3.37-1.31-6.53-3.7-8.92A12.5 12.5 0 0 0 16 3.2Zm0 23.16h-.01a10.5 10.5 0 0 1-5.35-1.46l-.38-.22-4.1 1.08 1.09-4-.25-.41a10.44 10.44 0 0 1-1.6-5.55c0-5.79 4.71-10.5 10.51-10.5 2.81 0 5.45 1.09 7.43 3.08a10.43 10.43 0 0 1 3.08 7.43c0 5.79-4.72 10.5-10.52 10.5Z"
        />
      </svg>
    </a>
  `,
  styles: [
    `
      .whatsapp-float-button {
        position: fixed;
        right: 1rem;
        bottom: 1rem;
        z-index: 40;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 3.5rem;
        height: 3.5rem;
        border-radius: 9999px;
        background: #25d366;
        color: #fff;
        box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22);
        transition:
          transform 0.2s ease,
          box-shadow 0.2s ease,
          background-color 0.2s ease;
      }

      .whatsapp-float-button:hover,
      .whatsapp-float-button:focus-visible {
        background: #1ebe5d;
        box-shadow: 0 14px 28px rgba(0, 0, 0, 0.28);
        outline: none;
        transform: translateY(-2px);
      }

      .whatsapp-float-button svg {
        width: 1.7rem;
        height: 1.7rem;
      }

      @media (min-width: 768px) {
        .whatsapp-float-button {
          right: 1.5rem;
          bottom: 1.5rem;
          width: 4rem;
          height: 4rem;
        }

        .whatsapp-float-button svg {
          width: 1.9rem;
          height: 1.9rem;
        }
      }
    `,
  ],
})
export class AppComponent {
  private router = inject(Router);

  ngOnInit() {
    // this.setupGoogleTag();
  }

  private setupGoogleTag(): void {
    if (!environment.gaMeasurementId) return;

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${environment.gaMeasurementId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };

    window.gtag('js', new Date());
    window.gtag('config', environment.gaMeasurementId);

    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        window.gtag?.('event', 'page_view', {
          page_path: e.urlAfterRedirects,
        });
      });
  }
}
